import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable} from 'rxjs';
import { MOCK_URL_FOOTER } from '@ibe.config';
import { INDRAApiService } from './api.indra.service';
import { INDRAStorageService } from './storage.indra.service';

@Injectable({
	providedIn: 'root'
})
export class INDRAFooterService {

	constructor (
		private http: HttpClient,
		private apiIndra: INDRAApiService,
		private storage: INDRAStorageService
	) { }

	public getFooter(): Observable<any> {
		return this.http.get<any>(MOCK_URL_FOOTER);
	}
}
